import {
  Box,
  Button,
  Divider,
  Drawer,
  Grid,
  InputAdornment,
  Stack,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DropDownComponent from "../components/browserJournalblocks/dropDownComponent";
import { setSearchKeyword } from "../store/slice/browseJournal";
import { Colors } from "../utils/constants";

import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import CloseIcon from "@mui/icons-material/CloseOutlined";
import IconButton from "@mui/material/IconButton";
import { useSearchParams } from "react-router-dom";
import {
  bookPublisherAutoSuggestion,
  booksAutoSuggestion,
} from "../api/browseJournal";
import AlphabeticalFilter from "../components/alphabeticalFilter/AlphabeticalFilter";
import TabView from "../components/browserJournalblocks/TabView";
import SearchFilterComponentOfBook from "../components/leftBarComponent/serachFilterOFBook";
import Books from "../screens/browseJournal/books";
import objectToQueryString from "../screens/browseJournal/objToQuery";
import { useAppSelector } from "../store/hooks";
import {
  clearAllFilters,
  updateBookCollection,
  updateBrowserPage,
  updateBrowserRow,
  updateCountryOfPublication,
  updateOnlyBooks,
  updateOpenAccess,
  updatePublisher,
  updateselectAlphabet,
  updateSourceType,
  updateSubject,
} from "../store/slice/browseFilterSlice";
import {
  updateBrowserSearch_term,
  updateBrowserPage as updateBrowserBookPackagerPage,
  updateBrowserRow as updateBrowserBookPackageRow,
  updateBrowserSearch_type,
} from "../store/slice/browseFilterSlicePackage";

import { setKeyword } from "../store/slice/browseJournal";
import {
  updateBookPublisherCollection,
  updateBrowserPage as updateBrowserPagePublisher,
  updateselectAlphabetPublisher,
  clearAllFilters as clearAllPublisherFilters,
  updateBrowserPage as updateBrowserPublisherPage,
  updateBrowserRow as updateBrowserPublisherRow,
} from "../store/slice/browserFilterSlicePublisher";
import { setSearchKeywordPublisher } from "../store/slice/browserPublisher";
import {
  goToTop,
  isPreferenceAddedSubjectAndDataType,
  showIsProfileToast,
} from "../utils/helper";
import BookPublisher from "./BookPublisher";
import { GetMyPreferenceData } from "../types/GetMySubjects.types";
import { useGetMySearchPreference } from "../api/Preferences/Subjects.api";
import { setModal } from "../store/slice/modalSlice";
import {
  clearDataTypeFilters,
  updateSubjectType,
} from "../store/slice/searchSlice";
import { AntSwitch } from "../components/basicSearchTopBar/basicSearchTopBar";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { usagelogApi } from "../api/usageReportApi";
import { Clear, FilterAlt, WidthFull } from "@mui/icons-material";
import CollectionsComponentOfBook from "../components/leftBarComponent/collectionsOfBook";
import CollectionsComponentOfBookPublisher from "../components/leftBarComponent/collectionOfBookPublisher";
import SearchFilterComponentOfBookPublisher from "../components/leftBarComponent/serachFilterOfBookPublisher";
import { checkBookBrowsePackageAvailability } from "../api/getCustomerDetailByIp";
import Packages from "./bookPackage";

export const BookSearch: React.FC = () => {
  const conditions = ["Starting With", "Containing"];
  const [text, setText] = useState<string[]>(["Title A-Z", "By Publisher"]);
  const [disabledTabs, setDisabledTabs] = useState<string[]>([]);
  const [autoSearch, setAutoSearch] = useState<any>([]);
  const [isOpen, setIsOpen] = useState(true); // To control the opening and closing of Autocomplete
  const query = new URLSearchParams(window.location.search);
  const [keyWord, setKeyWord] = React.useState(query.get("searchTerm") || "");
  const [keyWords, setKeyWords] = React.useState<any[]>([]);
  const [handleEnter, setHandleEnter] = React.useState(false);
  const [message, setMessage] = useState({ messages: "", open: false });
  const [selectedLetterTags, setSelectedLetterTags] = React.useState(
    Array(28).fill(false),
  );
  const [selectedLetterTagsPublisher, setSelectedLetterTagsPublisher] =
    React.useState(Array(28).fill(false));
  const [selectedTag, setSelectedTag] = React.useState<String>("");
  const [filters, setFilters] = React.useState<any>("");
  const [myPersonalLibrary, setMyPersonalLibrary] = useState(false);
  const [selectFilters, setSelectFilters] = useState(false);
  const [atoz, setatoz] = useState(false);
  const [atozPublisher, setatozPublisher] = useState(false);
  const [collectionFilter, setCollectionFilter] = useState("");
  const [tabIndex, setTabIndex] = useState<any>(0);

  const [keyWordPublisher, setKeyWordPublisher] = React.useState("");
  const [keyWordsPublisher, setKeyWordsPublisher] = React.useState<any[]>([]);
  const [autoSearchPublisher, setAutoSearchPublisher] = useState<any>([]);
  const [breadcrumsData, setBreadcrumsData] = useState<any>([]);

  const [keyWordPackage, setKeyWordPackage] = React.useState("");
  const [keyWordsPackage, setKeyWordsPackage] = React.useState<any[]>([]);
  const [atozPackage, setatozPackage] = useState(false);
  const [selectedLetterTagsPackage, setSelectedLetterTagsPackage] =
    React.useState(Array(28).fill(false));

  const [selectedTagPackage, setSelectedTagPackage] =
    React.useState<String>("");
  // To control the opening and closing of Autocomplete
  const [isOpenPublisher, setIsOpenPublisher] = useState(true); // To control the opening and closing of Autocomplete

  const searchContainOrStartWiths = useSelector((state: any) => state);
  const [FilterDrawer, setFilterDrawer] = useState(false);

  const isPreferenceEnabled = sessionStorage.getItem("preference") === "true";
  const [isPreference, setIsPreference] = useState(isPreferenceEnabled);
  const [isProfileUser, setIsProfileUser] = useState(true);
  const user_id = useAppSelector((state) => state.login.user_id);

  const { data: myPreference, refetch } = useGetMySearchPreference(
    user_id,
    isPreference,
  );

  const profileData = useAppSelector((state) => state.login);

  const profileData1 = useAppSelector(
    (state) => state.customer.customerDetails,
  );

  const packageHits = useSelector(
    // @ts-ignore
    (state) => state?.browsePackage?.browserResult,
  );

  const dispatch = useDispatch();

  const searchContainOrStartWith = useSelector(
    (state: any) => state.browseJournalSearch.containStartingWith,
  );
  const enabledTags = useSelector(
    (state: any) => state.browseJournalSearch.knownAlphasearch,
  );
  const bookData: any = useAppSelector(
    (state: any) => state.browseJournalSearch.bookResult,
  );
  const params = new URLSearchParams();

  const publisherDetails: any = useSelector(
    (state: any) => state.browserPublisher?.browserResult,
  );
  const onlybooks = useAppSelector(
    (state) => state.browseFilterSlice.onlyBooks,
  );

  const openAccess = useAppSelector(
    (state) => state.browseFilterSlice.openAccess,
  );

  const selectedFilters: any = useSelector(
    (state: any) => state.browseFilterSlice,
  );

  const l2Subjects = selectedFilters?.subject.filter(
    (val: any) => val.isSelected,
  );

  const selected_l2_subjects = l2Subjects?.map((val: any) => val.val);

  const l3Subjects: any = selectedFilters?.subject
    ?.filter((subject: any) => !subject.isSelected)
    .flatMap((subject: any) => subject.subjects_name_l3.buckets)
    .filter((bucket: any) => bucket.isChecked);

  const selected_l3_subjects = l3Subjects?.map((val: any) => val.val);

  const tab: string = sessionStorage.getItem("getTabSwitch") ?? "0";

  let bookmaster_id = query.get("bookmasterid") || "";

  const informaticscustomer_Id = sessionStorage.getItem(
    "informaticscustomer_id",
  );

  let [, setSearchParams] = useSearchParams();

  const l1SubjectIds = useAppSelector(
    (state) => state.searchReducer.subjectL1Type,
  );

  const searchKeyword = useSelector(
    (state: any) => state.browseJournalSearch.searchKeyword,
  );
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm")); // xs screens only

  useEffect(() => {
    if (keyWord) {
      params.set("searchTerm", keyWord);
    } else {
      params.delete("searchTerm");
      params.set("bookmasterid", bookmaster_id);
    }
    setSearchParams(params, {
      replace: true,
    });
  }, [keyWord, useSearchParams]);

  useEffect(() => {
    const breadcrumbData = generateFilterData(selectedFilters);
    setBreadcrumsData(breadcrumbData);
    const filterString = generatedFilterString();
    setFilters(filterString);
  }, [searchKeyword, selectedFilters]);

  useEffect(() => {
    const debounce = setTimeout(() => {
      const fetchData = async () => {
        try {
          const response = await checkBookBrowsePackageAvailability(
            informaticscustomer_Id ?? "0",
          );
          const hits = response?.data?.[0]?.[0]?.hits ?? 0;

          const tabs = ["Title A-Z", "By Publisher", "By Package"];
          const disable = hits === 0 ? ["By Package"] : [];

          setText(tabs);
          setDisabledTabs(disable);
        } catch (err) {
          console.error("Error fetching package availability", err);
        }
      };

      fetchData();
    }, 300);

    return () => clearTimeout(debounce);
  }, [informaticscustomer_Id]);

  const generateFilterData = (
    filters: any,
  ): { key: string; value: string }[] => {
    if (
      !filters ||
      typeof filters !== "object" ||
      Object.keys(filters).length === 0
    ) {
      return [];
    }

    // const result: { key: string; value: string }[] = [];
    const result = [];

    // collections
    if (filters.collectionsValueBook?.trim()) {
      result.push({
        key: "collectionsValueBook",
        value: filters.collectionsValueBook.trim(),
      });
    }

    // searchKeyword
    if (Array.isArray(searchKeyword)) {
      searchKeyword.forEach((item: any) => {
        const term = item?.words?.trim();
        if (term) {
          result.push({ key: "search-term", value: term });
        }
      });
    }

    if (Array.isArray(keyWord)) {
      keyWord.forEach((item: any) => {
        const term = item?.words?.trim();
        if (term) {
          result.push({ key: "search-term", value: term });
        }
      });
    }

    // subjects
    // const subjects: string[] =
    //   filters.subject?.flatMap((sub: any) => {
    //     if (sub?.isSelected && sub?.val) {
    //       return [sub.val];
    //     }
    //     return (
    //       sub?.subjects_name_l3?.buckets
    //         ?.filter((b: any) => b?.isChecked)
    //         .map((b: any) => b.val) || []
    //     );
    //   }) || [];

    // subjects.forEach((subject: string) => {
    //   result.push({ key: "subject", value: subject });
    // });

    // filters.subject?.forEach?.((sub: string) => {
    //   result.push({ key: "subject", value: sub });
    // });

    const subjects = (filters.subject || [])
      .map((sub: any) => {
        if (sub.isSelected) {
          return sub.val;
        } else {
          return (sub.subjects_name_l3?.buckets || [])
            .filter((b: any) => b.isChecked)
            .map((b: any) => b.val);
        }
      })
      .flat();

    console.log("subjects", subjects);

    if (subjects.length > 0) {
      subjects.map((item: any) => {
        result.push({
          key: "subject",
          value: item,
        });
      });
    }

    // countryOfPublication
    filters.countryOfPublication?.forEach?.((country: string) => {
      result.push({ key: "countryOfPublication", value: country });
    });

    // publisher
    filters.publisher?.forEach?.((publisher: string) => {
      result.push({ key: "publisher", value: publisher });
    });

    // Source Index
    filters.sourceType?.forEach?.((item: string) => {
      result.push({ key: "sourceType", value: item });
    });

    return result;
  };

  function generatedFilterString() {
    const publisherCountry = selectedFilters?.countryOfPublication?.length
      ? "&" +
        objectToQueryString({
          primary_publisher_country:
            '("' + selectedFilters?.countryOfPublication?.join('" OR "') + '")',
        })
      : "";

    // const subjects = selectedFilters?.subject?.length
    //   ? "&" +
    //     objectToQueryString({
    //       subjects_name_l3: encodeURIComponent(
    //         '("' + selectedFilters?.subject?.join('" OR "') + '")'
    //       ),
    //     })
    //   : "";

    const subjects =
      selected_l2_subjects.length > 0 && selected_l3_subjects.length > 0
        ? "&" +
          objectToQueryString({
            "fq__(subjects_name_l2": encodeURIComponent(
              '("' +
                selected_l2_subjects.map((val: any) => val).join('" OR "') +
                '")',
            ),
          }) +
          " OR " +
          objectToQueryString({
            subjects_name_l3: encodeURIComponent(
              '("' +
                selected_l3_subjects.map((val: any) => val).join('" OR "') +
                '")' +
                ")",
            ),
          })
        : selected_l2_subjects.length > 0
          ? "&" +
            objectToQueryString({
              fq__subjects_name_l2: encodeURIComponent(
                '("' +
                  selected_l2_subjects.map((val: any) => val).join('" OR "') +
                  '")',
              ),
            })
          : selected_l3_subjects.length > 0
            ? "&" +
              objectToQueryString({
                fq__subjects_name_l3: encodeURIComponent(
                  '("' +
                    selected_l3_subjects.map((val: any) => val).join('" OR "') +
                    '")',
                ),
              })
            : "";

    const publisher = selectedFilters?.publisher?.length
      ? "&" +
        objectToQueryString({
          publisher_name: encodeURIComponent(
            '("' + selectedFilters?.publisher?.join('" OR "') + '")',
          ),
        })
      : "";

    // }

    return publisherCountry + subjects + publisher;
  }

  const search = async () => {
    logBasicSearchUsageData(128);
    clearAllFilters();
    dispatch(
      setSearchKeyword({
        searchType: searchContainOrStartWith,
        words: keyWord,
      }),
    );
    setKeyWords([
      ...keyWords,
      { searchType: searchContainOrStartWith, words: keyWord },
    ]);

    dispatch(updateselectAlphabet(""));
    dispatch(updateBrowserPage(1));
  };

  useEffect(() => {
    if (keyWord !== "") search();
    goToTop();
  }, []);

  useEffect(() => {
    setTabIndex(parseInt(tab));
  }, []);

  // FOR TITLE A-Z
  const updateSelectedTags = (element: any, index: any) => {
    logBasicSearchUsageData(129);
    let temp = Array(28).fill(false);
    dispatch(updateBrowserPage(1));
    // usageReport("86");
    // logBasicSearchUsageData(86);

    if (selectedLetterTags[element]) {
      setSelectedLetterTags(temp);
      setSelectedTag("");
      dispatch(updateselectAlphabet(""));
    } else {
      if (element == 0) {
        temp[0] = true;
        setKeyWord("");
        setSelectedLetterTags(temp);
        setSelectedTag("");
        dispatch(
          setSearchKeyword({
            searchType: "",
            words: "",
          }),
        );

        dispatch(updateselectAlphabet(""));
      } else if (element == 1) {
        temp[1] = true;
        setSelectedLetterTags(temp);
        dispatch(updateselectAlphabet("1"));
        setSelectedTag("");
      } else {
        temp[element] = true;
        setSelectedLetterTags(temp);
        setSelectedTag(String.fromCharCode(element + 63));
        dispatch(updateselectAlphabet(String.fromCharCode(element + 63)));
      }
    }
  };

  const updateSelectedTagsPublisher = (element: any, index: any) => {
    logBasicSearchUsageData(129);

    let temp = Array(28).fill(false);
    dispatch(updateBrowserPagePublisher(1));
    if (selectedLetterTagsPublisher[element]) {
      setSelectedLetterTagsPublisher(temp);
      // setSelectedTagPublisher("");
      dispatch(updateselectAlphabetPublisher(""));
    } else {
      if (element == 0) {
        setKeyWordPublisher("");
        dispatch(setSearchKeywordPublisher([]));
        temp[0] = true;
        setSelectedLetterTagsPublisher(temp);
        // setSelectedTagPublisher("");
        dispatch(updateselectAlphabetPublisher(""));
      } else if (element == 1) {
        temp[1] = true;
        setSelectedLetterTagsPublisher(temp);
        dispatch(updateselectAlphabetPublisher("1"));
        // setSelectedTagPublisher("");
      } else {
        temp[element] = true;
        setSelectedLetterTagsPublisher(temp);
        // setSelectedTagPublisher(String.fromCharCode(element + 63));
        dispatch(
          updateselectAlphabetPublisher(String.fromCharCode(element + 63)),
        );
      }
    }
  };

  const onChangeKeyword_Books = async (e: {
    target: { value: React.SetStateAction<string> };
  }) => {
    setKeyWord(e.target.value);
    let searchedLetters: any = "";
    if (e.target.value.length >= 3) {
      // @ts-ignore
      let searchedArrayLetters = e.target.value.split(" ");
      searchedArrayLetters?.map((element: string) => {
        searchedLetters += `${element}\\ of\\ `;
      });

      let apiJournalData = {
        book_name_tk: `${searchedLetters.slice(0, -6)}*`,
      };

      let response = await booksAutoSuggestion(
        objectToQueryString(apiJournalData),
        l1SubjectIds,
      );

      setAutoSearch(response?.data?.data?.jsonfacets?.book_name_tk?.buckets);
    }
    dispatch(setKeyword(e.target.value));
  };
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    dispatch(clearAllFilters());
    setFilters("");
    // setFiltersPublisher("");
    // setKeyWordPublisher("");
    // dispatch(clearAllFiltersPackage());
    // dispatch(clearAllFiltersPublisher());
    dispatch(setSearchKeyword([]));
    dispatch(setSearchKeywordPublisher([]));
    // setKeyWordsPackage([]);
    dispatch(updateBrowserSearch_term([]));
    dispatch(updateBookCollection(""));
    dispatch(updateBookPublisherCollection(""));

    // setKeyWordPackage("");
    // dispatch(tabSwitchBrowserJournal(newValue));
    // dispatch(updateCurrentUpdate(!openAccess));

    if (newValue == 0) {
      logBasicSearchUsageData(122);
      dispatch(clearAllFilters());
      dispatch(updateBrowserPage(1));
      dispatch(updateBrowserRow(15));
      dispatch(updateBrowserBookPackagerPage(1));
      dispatch(updateBrowserBookPackageRow(15));
      setKeyWordPublisher("");
    }

    if (newValue == 1) {
      logBasicSearchUsageData(127);
      dispatch(clearAllPublisherFilters());
      dispatch(updateBrowserPublisherPage(1));
      dispatch(updateBrowserPublisherRow(15));
      dispatch(updateBrowserBookPackagerPage(1));
      dispatch(updateBrowserBookPackageRow(15));
      setKeyWord("");
    }

    if (newValue == 2) {
      logBasicSearchUsageData(141);
      dispatch(clearAllPublisherFilters());
      dispatch(updateBrowserPublisherPage(1));
      dispatch(updateBrowserPublisherRow(15));

      dispatch(clearAllFilters());
      dispatch(updateBrowserPage(1));
      dispatch(updateBrowserRow(15));
      setKeyWord("");
      setKeyWordPublisher("");
    }

    sessionStorage.setItem("getTabSwitch", newValue.toString());
    setTabIndex(newValue);
  };

  const onChangeKeywordPublisher = async (e: {
    target: { value: React.SetStateAction<string> };
  }) => {
    setKeyWordPublisher(e.target.value);
    if (e.target.value.length >= 0) {
      // @ts-ignore
      let targetVal: string = e.target.value?.split(" ")?.join("\\ ");
      let apiData = {
        page: 1,
        rows: 15,
        profileuserid: searchContainOrStartWiths.login.user_id,
        fq__resource_type: `(${searchContainOrStartWiths.searchReducer.dataType
          .join(" OR ")
          .replace(/[()]/g, "")})`,
        publisher_name_tk: encodeURIComponent(`${targetVal}*`),
        fq__active_flag: true,
        facet_fields: "publisher_name",
        sort: "publisher_name_tk asc",
        op_mode: "and",
        fl: "publisher_name_tk, primary_publisher_country,publisher_id",
        group_field: "publisher_name_tk",
        group_ngroups: true,
      };
      let res = await bookPublisherAutoSuggestion(objectToQueryString(apiData));
      setAutoSearchPublisher(
        res?.data?.data?.facets?.facet_fields?.publisher_name,
      );
    }
  };

  const triggerPreference = useRef(0);

  async function checkPreferenceAdded(myPreference: GetMyPreferenceData) {
    if (!myPreference) return;

    const filteredSelectedTags = myPreference?.DataTypes.filter(
      ({ is_favorite }: any) => is_favorite,
    ).map(({ datatype_id }) => datatype_id);
    if (filteredSelectedTags?.filter((ele: any) => ele !== 2)?.length === 0) {
      setIsPreference(false);
      sessionStorage.setItem("preference", "false");
    }
  }

  function handlePreference(event: React.ChangeEvent<HTMLInputElement>) {
    logBasicSearchUsageData(112);
    if (isProfileUser) {
      let isMyPrefAdded: boolean = true;
      if (myPreference) {
        isMyPrefAdded = isPreferenceAddedSubjectAndDataType(myPreference);
      }

      if (!isMyPrefAdded && event.target.checked) {
        dispatch(
          setModal({
            modalType: "PREFERENCE",
            modalProps: {
              open: true,
              checkPreferenceAdded,
            },
          }),
        );
      } else {
        setIsPreference(event.target.checked);
      }
      if (!event.target.checked) {
        dispatch(clearDataTypeFilters());
      }
      sessionStorage.setItem("preference", event.target.checked.toString());
      triggerPreference.current = triggerPreference.current + 1;
    } else {
      showIsProfileToast("Please login as profile user to use the preferences");
    }
  }

  async function applyPreference() {
    // if (!user_id || !customerData) return;
    if (!myPreference) return;

    dispatch(clearDataTypeFilters());

    if (isPreference && myPreference) {
      // Update preference data type
      const preferedSources = myPreference.DataTypes.filter(
        (type) => type.is_favorite,
      )?.map((source) => source.datatype_id);

      if (preferedSources.includes(1)) {
        preferedSources.push(2);
        preferedSources.push(24);
        preferedSources.push(5);
      }

      // dispatch(updateDataType(preferedSources));

      // update subject ids
      const preferedSubjects = myPreference.Subjects?.map((l1) =>
        l1.subject2_details.filter((l2) => l2.is_favorite),
      )
        .flat()
        ?.map((l2) => {
          return {
            datsubjectmasterlevel1_id: -1, //Unused, Just for Integrity's Sake
            datsubjectmasterlevel2_id: l2.subject_id2,
            level2subject_name: l2.subject_name2,
          };
        });

      const subjectIds = preferedSubjects?.map(
        (x) => x.datsubjectmasterlevel2_id,
      );

      dispatch(updateSubjectType(subjectIds));
      // dispatch(search());
    } else {
      // const subjectIds = customerData.subject?.map(
      //   (x: any) => x?.datsubjectmasterlevel2_id
      // );
      // const dataTypeIds = ["1", "2", "3", "4", "8", "24"];
      // // update datatype ids
      // dispatch(updateDataType(dataTypeIds));
      //Update Subject Ids
      // dispatch(updateSubjectType(subjectIds));
      // dispatch(search());
    }
  }

  useEffect(() => {
    triggerPreference.current && applyPreference();
  }, [isPreference, myPreference]);

  function openPreferenceInfoModal() {
    dispatch(
      setModal({
        modalType: "PREFERENCE_INFO_MODEL",
        modalProps: {
          isOpen: true,
          from: "booksearch",
        },
      }),
    );
  }

  function getContextId(collectionValue: any) {
    switch (collectionValue) {
      case "J-GateCollection":
        return 1;
      case "Consortia Collections":
        return 2;
      case "My Library Collections":
        return 3;
      case "MyPersonalLibraryCollection":
        return 4;
      case "ONOS Collections":
        return 5;
      case "Library OPAC":
        return 6;
      case "Open Access Collections":
        return 7;
      default:
        return null;
    }
  }

  const selectedCollectionFromBookAz = useAppSelector(
    (state: any) => state.browseFilterSlice,
  );

  const contextIdFromAz = getContextId(
    selectedCollectionFromBookAz?.collectionsValueBook,
  );

  const selectedCollectionFromBookByPublisher = useAppSelector(
    (state: any) => state.browserFilterSlicePublisher,
  );

  const contextIdFromByPublisher = getContextId(
    selectedCollectionFromBookByPublisher?.collectionsValueBookPublisher,
  );

  let contextId: any;
  if (tabIndex === 0) {
    contextId = contextIdFromAz;
  } else if (tabIndex === 1) {
    contextId = contextIdFromByPublisher;
  } else {
    contextId = null;
  }

  const logBasicSearchUsageData = (usageActionID: any, details?: any) => {
    const userId = sessionStorage.getItem("user_id");
    const informaticscustomer_Id = sessionStorage.getItem(
      "informaticscustomer_id",
    );
    const user_ipv4_address =
      sessionStorage.getItem("user_ipv4_address") || null;
    const userMasterId = profileData.user_id
      ? profileData.user_id
      : userId
        ? userId
        : null;
    const informaticscustomerId = profileData.informaticscustomer_id
      ? profileData.informaticscustomer_id
      : informaticscustomer_Id
        ? informaticscustomer_Id
        : null;
    const consortiamasterId =
      profileData1 && profileData1.consortiamaster_id
        ? profileData1.consortiamaster_id
        : null;
    const sessionKey = profileData.session_key ? profileData.session_key : null;
    const bookId = details?.bookmaster_id ?? null;
    usagelogApi(
      userMasterId,
      informaticscustomerId,
      consortiamasterId,
      usageActionID,
      contextId,
      null,
      null,
      null,
      null,
      null,
      // profileData.ip_v4,
      user_ipv4_address,
      null,
      sessionKey,
      1,
      null,
      0,
      bookId,
    );
  };
  const buttonConfigs = [
    {
      condition: onlybooks,
      onClick: () => {
        dispatch(updateOnlyBooks(false));
      },
      label: "Chapter Only",
    },
    {
      condition: openAccess,
      onClick: () => {
        dispatch(updateOpenAccess(false));
      },
      label: "Open Access",
    },
  ];

  const ResponsiveCombinedButtons = ({
    allAppliedFilter, // array of applied filters; each object has a key and value
    buttonConfigs, // array of config buttons with condition, onClick, and label properties
    isSmallScreen, // boolean flag for xs screens
    onRemove, // function to remove a filter item (expects key and value)
    webStyle,
    getBreadscrumLabel,
  }: any) => {
    const [showAll, setShowAll] = useState(false);
    // Normalize applied filters into our common button shape
    const filterButtons =
      Array.isArray(allAppliedFilter) && allAppliedFilter.length > 0
        ? // [{key:"",value:""}]
          allAppliedFilter.map((obj, index) => ({
            type: "filter",
            key: obj?.key || index,
            label: getBreadscrumLabel(obj),
            // For the first filter, we don’t attach an onClick (or you can allow removal as needed)
            onClick:
              index > 0 ? () => onRemove(obj?.key, obj?.value) : undefined,
            // We only show a CloseIcon for filters beyond the first (adjust if needed)
            showIcon: index > 0,
          }))
        : [];

    // Normalize config buttons – include only those where the condition is true
    const configButtons = buttonConfigs
      .filter((btn: { condition: any }) => btn.condition)
      .map((btn: { label: any; onClick: any }, index: any) => ({
        type: "config",
        key: `config-${index}-${btn.label}`,
        label: btn.label,
        onClick: btn.onClick,
        showIcon: true,
      }));

    // Combine both arrays
    const allButtons = [...filterButtons, ...configButtons];

    if (allButtons.length === 0) return null;

    // For small screens, show only the first button if not expanded
    const visibleButtons =
      isSmallScreen && !showAll ? allButtons.slice(0, 1) : allButtons;
    const remainingCount = allButtons.length - visibleButtons.length;

    return (
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Stack direction="row" spacing={2} flexWrap="wrap">
          {visibleButtons.map((btn, index) => (
            <Button
              key={btn.key}
              size="small"
              variant="outlined"
              // Show a CloseIcon for filter buttons (if applicable)
              endIcon={btn.showIcon ? <CloseIcon /> : null}
              sx={webStyle.searchTextFont}
              onClick={btn.onClick}
            >
              {btn.label == "J-GateCollection"
                ? "J-Gate Collection"
                : btn.label == "MyPersonalLibraryCollection"
                  ? "My Personal Library Collections"
                  : btn.label}
            </Button>
          ))}

          {/* If on small screen and not all buttons are visible, show the More button */}
          {isSmallScreen && !showAll && allButtons.length > 1 && (
            <Button
              size="small"
              variant="text"
              onClick={() => setShowAll(true)}
              sx={{ textTransform: "none" }}
            >
              More +{remainingCount}
            </Button>
          )}
          {isSmallScreen && showAll && allButtons.length > 1 && (
            <Button
              size="small"
              variant="text"
              onClick={() => setShowAll(false)}
              sx={{ textTransform: "none", mt: 1 }}
            >
              Less
            </Button>
          )}
        </Stack>
      </Box>
    );
  };

  const getBreadscrumLabel = (obj: any) => {
    if (obj?.key === "search-term") {
      return obj?.value;
    }
    if (obj?.key === "collectionsValueBook") {
      return obj?.value;
    }

    if (obj?.key === "subject") {
      return obj?.value;
    }

    if (obj?.key === "countryOfPublication") {
      return obj?.value;
    }
    return obj?.value?.replace(",", "");
  };

  function removeSearchKeyword(value: string) {
    dispatch(setKeyword(""));
    setKeyWord("");
    dispatch(
      setSearchKeyword({
        searchType: searchContainOrStartWith,
        words: "",
      }),
    );
  }

  const removeFilter = (
    value: string,
    arr: string[],
    setterFunction: Function,
    key = "other",
  ) => {
    // let filteredValues
    if (key == "subject") {
      // console.log("=====",arr,selected_l2_subjects,selected_l3_subjects)
      let filteredValues = arr?.map((subject: any) => {
        // Deep clone the subject and its nested objects
        const updatedSubject = {
          ...subject,
          subjects_name_l3: subject.subjects_name_l3
            ? {
                ...subject.subjects_name_l3,
                buckets: subject.subjects_name_l3.buckets
                  ? subject.subjects_name_l3.buckets.map((bucket: any) => {
                      if (bucket.val === value && bucket.isChecked === true) {
                        return { ...bucket, isChecked: false };
                      }
                      return bucket;
                    })
                  : [],
              }
            : undefined,
        };

        // Unselect "agriculture sciences"
        if (
          updatedSubject.val === value &&
          updatedSubject.isSelected === true
        ) {
          updatedSubject.isSelected = false;
          updatedSubject.subjects_name_l3 = subject.subjects_name_l3
            ? {
                ...subject.subjects_name_l3,
                buckets: subject.subjects_name_l3.buckets
                  ? subject.subjects_name_l3.buckets.map((bucket: any) => ({
                      ...bucket,
                      isChecked: false,
                    }))
                  : [],
              }
            : undefined;
        }

        return updatedSubject;
      });
      dispatch(setterFunction(filteredValues));
    } else {
      let filteredValues = arr?.filter((data) => data != value);
      dispatch(setterFunction(filteredValues));
    }
    // remove data from the allappliedfilter state
    //   dispatch(removeAllFilterType(value));

    //dispatch(search());
    //   dispatch(search("", null, true));
  };

  function onRemove(key: string, value: string) {
    if (key === "search-term") {
      removeSearchKeyword(value);
    }
    if (key === "collectionsValueBook") {
      dispatch(updateBookCollection("J-GateCollection"));
    }

    if (key === "subject") {
      removeFilter(value, selectedFilters.subject, updateSubject, "subject");
    }

    if (key === "countryOfPublication") {
      removeFilter(
        value,
        selectedFilters.countryOfPublication,
        updateCountryOfPublication,
      );
    }
    if (key === "publisher") {
      removeFilter(value, selectedFilters.publisher, updatePublisher);
    }
    if (key === "sourceType") {
      removeFilter(value, selectedFilters.sourceType, updateSourceType);
    }
  }

  function clearAll() {
    // dispatch(sliceSearchTerm());
    dispatch(clearAllFilters());
    dispatch(setKeyword(""));
    setKeyWord("");
    dispatch(updateOnlyBooks(false));
    dispatch(updateOpenAccess(false));
    dispatch(
      setSearchKeyword({
        searchType: searchContainOrStartWith,
        words: "",
      }),
    );
  }

  const onChangeKeywordPackage = (e: {
    target: { value: React.SetStateAction<string> };
  }) => {
    setKeyWordPackage(e.target.value);

    // dispatch(setKeyword(e.target.value));
  };

  // FOR PACKAGE
  const updateSelectedTagsPackage = (element: any, index: any) => {
    let temp = Array(28).fill(false);
    logBasicSearchUsageData(129);
    if (selectedLetterTags[element]) {
      setSelectedLetterTagsPackage(temp);
      setSelectedTagPackage("");
    } else {
      if (element == 0) {
        temp[0] = true;
        setSelectedLetterTagsPackage(temp);
        setSelectedTagPackage("");
        dispatch(updateBrowserSearch_type(""));
        dispatch(updateBrowserSearch_term(""));

        setKeyWordPackage("");
      } else if (element == 1) {
        temp[1] = true;
        setSelectedLetterTagsPackage(temp);
        setSelectedTagPackage("");
      } else {
        temp[element] = true;
        setSelectedLetterTagsPackage(temp);
        setSelectedTagPackage(String.fromCharCode(element + 63));
        dispatch(updateBrowserSearch_type("1"));
        dispatch(updateBrowserSearch_term(String.fromCharCode(element + 63)));
      }
    }
  };

  return (
    <React.Fragment>
      <Box style={{ display: "flex", justifyItems: "center" }}>
        <Typography sx={webStyles.textResult} variant="h5">
          Book Finder
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            margin: "1% 3.5% 0% 0%",
          }}
        >
          <Typography sx={{ fontWeight: "500" }}>Preferences</Typography>
          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            marginLeft={"6%"}
          >
            <AntSwitch
              checked={isPreference}
              inputProps={{ "aria-label": "ant design" }}
              onChange={handlePreference}
            />
          </Stack>
          <Stack>
            <IconButton size="medium" onClick={openPreferenceInfoModal}>
              <InfoOutlinedIcon fontSize="inherit" />
            </IconButton>
          </Stack>
        </Box>
      </Box>
      <TabView
        text={text}
        value={tabIndex}
        handleChange={handleChange}
        // disabledTabs={disabledTabs}
      ></TabView>
      {tabIndex === 0 ? (
        <>
          {" "}
          <Box
            mr="3%"
            ml="3%"
            mt={"1%"}
            sx={{
              display: "flex",
              flexDirection: {
                xs: "column",
                sm: "row",
                md: "row",
                lg: "row",
                xl: "row",
              },
              alignItems: "center",
            }}
          >
            <DropDownComponent items={conditions}></DropDownComponent>
            <Box style={{ flex: 1, alignSelf: "center", width: "100%" }}>
              <Autocomplete
                id="free-solo-demo"
                freeSolo
                options={autoSearch?.map((option: any) => option.val) || []}
                open={isOpen}
                onOpen={() => setIsOpen(true)}
                onClose={() => setIsOpen(false)}
                value={keyWord}
                sx={{ width: 300 }}
                // @ts-ignore
                onChange={(event: any, newValue: string) => {
                  setAutoSearch([]);
                  setKeyWord(newValue);
                  setKeyWords([
                    ...keyWords,
                    { searchType: searchContainOrStartWith, words: keyWord },
                  ]);
                  setIsOpen(false);
                }}
                // value={keyWord}
                size="small"
                // @ts-ignore
                style={{ width: "100%" }}
                onKeyDown={(e) => {
                  //logBasicSearchUsageData(88);
                  if (e.key === "Enter" && keyWord) {
                    //usageReport("88");
                    // logBasicSearchUsageData(88);
                    setKeyWords([
                      ...keyWords,
                      { searchType: searchContainOrStartWith, words: keyWord },
                    ]);
                    dispatch(
                      setSearchKeyword({
                        searchType: searchContainOrStartWith,
                        words: keyWord,
                      }),
                    );
                    dispatch(updateselectAlphabet(""));

                    // setHandleEnter(true);
                    setIsOpen(false);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    placeholder="Title"
                    onChange={onChangeKeyword_Books}
                    sx={[
                      webStyles.textInputText,
                      { width: "100%", marginRight: "0.5%" },
                    ]}
                    {...params}
                    InputProps={{
                      ...params.InputProps,
                      // type: "search",
                      endAdornment: (
                        <InputAdornment position="end">
                          {keyWord ? (
                            <IconButton
                              onClick={() => {
                                dispatch(setKeyword(""));
                                setKeyWord("");
                                dispatch(
                                  setSearchKeyword({
                                    searchType: searchContainOrStartWith,
                                    words: "",
                                  }),
                                );
                              }}
                            >
                              <CloseIcon />
                            </IconButton>
                          ) : null}
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
              />
            </Box>
            <Button
              variant="contained"
              sx={{
                ...webStyles.button,
                width: { xs: "100%", sm: "10%" },
                marginTop: { xs: "10px", sm: "0px" },
              }}
              onClick={async () => {
                let res;
                //usageReport("88");
                // logBasicSearchUsageData(88);
                if (keyWord == "") {
                  setMessage({
                    messages: "Try for some appropriate keywords / terms",
                    open: true,
                  });
                  return;
                }

                search();
              }}
            >
              Search
            </Button>
          </Box>
          <Box ml={"3%"} mr={"3%"} mt={"1%"} display={"flex"}>
            <AlphabeticalFilter
              selectedTags={selectedLetterTags}
              selectOnClick={updateSelectedTags}
              enabledTags={enabledTags}
            />
          </Box>{" "}
          {/* <Box ml={"3%"} mr={"3%"} mt={"1%"} display={"flex"}>
            {buttonConfigs
              .filter((btn) => btn.condition)
              .map((btn, index) => (
                <Button
                  key={index}
                  size="small"
                  variant="outlined"
                  endIcon={<CloseIcon />}
                  sx={webStyles.searchTextFont}
                  onClick={btn.onClick}
                >
                  {btn.label}
                </Button>
              ))}
          </Box> */}
          <Box ml={"3%"} mr={"3%"} mt={"1%"} display={"flex"}>
            <Box
              sx={[
                {
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap",
                  gap: 1,
                  alignItems: "center",
                },
              ]}
            >
              <Button
                sx={{ height: 22, fontSize: { xs: "0.878rem", sm: "16px" } }}
                onClick={clearAll}
              >
                Clear All
              </Button>
              <ResponsiveCombinedButtons
                allAppliedFilter={breadcrumsData}
                buttonConfigs={buttonConfigs}
                isSmallScreen={isSmallScreen}
                onRemove={onRemove}
                webStyle={webStyles}
                getBreadscrumLabel={getBreadscrumLabel}
              />
            </Box>
          </Box>
        </>
      ) : tabIndex === 1 ? (
        <>
          <Box
            mr="3%"
            ml="3%"
            mt={"1%"}
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              alignItems: "center",
            }}
          >
            <DropDownComponent items={conditions}></DropDownComponent>
            <Box style={{ flex: 1, alignSelf: "center", width: "100%" }}>
              <Autocomplete
                id="free-solo-demo"
                freeSolo
                options={autoSearchPublisher?.map(
                  (option: any) => Object.keys(option) || [],
                )}
                open={isOpenPublisher}
                onOpen={() => setIsOpenPublisher(true)}
                onClose={() => setIsOpenPublisher(false)}
                value={keyWordPublisher}
                // @ts-ignore
                onChange={(event: any, newVal: string) => {
                  setAutoSearchPublisher([]);
                  setKeyWordPublisher(newVal[0]);
                  setKeyWordsPublisher([
                    ...keyWordsPublisher,
                    {
                      searchType: searchContainOrStartWith,
                      words: keyWordPublisher,
                    },
                  ]);
                }}
                sx={{ width: 300 }}
                //  onChange={() => {}}
                size="small"
                // @ts-ignore
                style={{ width: "100%" }}
                onKeyDown={(e) => {
                  if (e.key === "Enter" && keyWordPublisher) {
                    setKeyWordsPublisher([
                      ...keyWordsPublisher,
                      {
                        searchType: searchContainOrStartWith,
                        words: keyWordPublisher,
                      },
                    ]);
                    dispatch(
                      setSearchKeywordPublisher({
                        searchType: searchContainOrStartWith,
                        words: keyWordPublisher,
                      }),
                    );
                    setHandleEnter(true);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    placeholder="Search by Publisher Name"
                    onChange={onChangeKeywordPublisher}
                    sx={[
                      webStyles.textInputText,
                      { width: "100%", marginRight: "0.5%" },
                    ]}
                    {...params}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <InputAdornment position="end">
                          {keyWordPublisher ? (
                            <IconButton
                              onClick={() => {
                                setKeyWordPublisher("");
                                dispatch(
                                  setSearchKeywordPublisher({
                                    searchType: searchContainOrStartWith,
                                    words: "",
                                  }),
                                );
                              }}
                            >
                              <CloseIcon />
                            </IconButton>
                          ) : null}
                        </InputAdornment>
                      ),
                    }}
                  ></TextField>
                )}
              />
            </Box>

            <Button
              variant="contained"
              sx={{
                ...webStyles.button,
                width: {
                  xs: "100%",
                  sm: "10%",
                },
                marginTop: { xs: "9px", sm: "0px" },
              }}
              onClick={async () => {
                let res;
                logBasicSearchUsageData(128);
                if (keyWordPublisher == "") {
                  setMessage({
                    messages: "Try for some appropriate keywords / terms",
                    open: true,
                  });
                  return;
                }
                clearAllFilters();

                setKeyWordsPublisher([
                  ...keyWordsPublisher,
                  {
                    searchType: searchContainOrStartWith,
                    words: keyWordPublisher,
                  },
                ]);
                dispatch(
                  setSearchKeywordPublisher({
                    searchType: searchContainOrStartWith,
                    words: keyWordPublisher,
                  }),
                );

                setatozPublisher(true);
              }}
            >
              Search
            </Button>
          </Box>
          <Box ml={"3%"} mr={"3%"} mt={"1%"} display={"flex"}>
            <AlphabeticalFilter
              selectedTags={selectedLetterTagsPublisher}
              selectOnClick={updateSelectedTagsPublisher}
              enabledTags={enabledTags}
            />
          </Box>{" "}
          {/* <Box ml={"3%"} mr={"3%"} mt={"1%"} display={"flex"}>
            {buttonConfigs
              .filter((btn) => btn.condition)
              .map((btn, index) => (
                <Button
                  key={index}
                  size="small"
                  variant="outlined"
                  endIcon={<CloseIcon />}
                  sx={webStyles.searchTextFont}
                  onClick={btn.onClick}
                >
                  {btn.label}
                </Button>
              ))}
          </Box> */}
        </>
      ) : tabIndex === 2 ? (
        <>
          <Box
            mr="3%"
            ml="3%"
            mt={"1%"}
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              alignItems: "center",
            }}
          >
            <DropDownComponent
              items={conditions}
              from={"package"}
            ></DropDownComponent>
            <Box
              style={{
                flex: 1,
                alignSelf: "center",
                display: "flex",
                width: "100%",
              }}
            >
              <TextField
                onChange={onChangeKeywordPackage}
                value={keyWordPackage}
                size="small"
                placeholder="Search by  Package Name"
                sx={[
                  webStyles.textInputText,
                  { alignSelf: "center", flex: 1, marginRight: "0.5%" },
                ]}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    setKeyWordsPackage([
                      {
                        searchType: searchContainOrStartWith,
                        words: keyWordPackage,
                      },
                    ]);
                    dispatch(updateBrowserSearch_term(keyWordPackage));

                    setHandleEnter(true);
                  }
                }}
              ></TextField>
            </Box>
            <Button
              variant="contained"
              sx={{ ...webStyles.button, mt: { xs: 1, sm: 0 } }}
              onClick={async () => {
                let res;
                if (keyWordPackage == "") {
                  setMessage({
                    messages: "Try for some appropriate keywords / terms",
                    open: true,
                  });
                  return;
                }
                clearAllFilters();

                setKeyWordsPackage([
                  ...keyWords,
                  {
                    searchType: searchContainOrStartWith,
                    words: keyWordPackage,
                  },
                ]);
                dispatch(updateBrowserSearch_term(keyWordPackage));
                if (tabIndex == 2) {
                  setatozPackage(true);
                } else if (tabIndex == 1) {
                  // dispatch(setSearchKeyword(keyWord));
                  // setPublisher(true);
                }
              }}
            >
              Search
            </Button>
          </Box>
          <Box ml={"3%"} mr={"3%"} mt={"1%"} display={"flex"}>
            <AlphabeticalFilter
              selectedTags={selectedLetterTagsPackage}
              selectOnClick={updateSelectedTagsPackage}
            />
          </Box>{" "}
        </>
      ) : null}
      <Box sx={webStyles.mainContainer}>
        <Box ml={"3%"} mr={"3%"}>
          <Grid container mt={"2%"} direction={{ xs: "column", md: "row" }}>
            {tabIndex == 0 ? (
              <Grid
                item
                xs={3}
                md={3}
                sx={{ display: { xs: "none", sm: "none", md: "initial" } }}
              >
                <Box sx={{ paddingBlock: 2 }}>
                  <Typography
                    fontWeight={"700"}
                    fontSize={"20px"}
                    lineHeight={"24px"}
                    style={webStyles.resulteText}
                  >
                    Results{" "}
                    {tabIndex === 0
                      ? bookData?.hits
                        ? bookData?.hits.toLocaleString("en-US")
                        : ""
                      : publisherDetails?.grouped?.publisher_name_tk?.ngroups
                        ? publisherDetails?.grouped?.publisher_name_tk?.ngroups.toLocaleString(
                            "en-US",
                          )
                        : ""}
                  </Typography>
                </Box>
                <CollectionsComponentOfBook
                  setMyPersonalLibrary={setMyPersonalLibrary}
                  setFilters={setFilters}
                  setCollectionFilter={setCollectionFilter}
                ></CollectionsComponentOfBook>

                <SearchFilterComponentOfBook
                  setFilters={setFilters}
                  from={tabIndex === 0 ? "title_atoz" : "bypublisher"}
                ></SearchFilterComponentOfBook>
              </Grid>
            ) : tabIndex == 1 ? (
              <Grid
                item
                xs={3}
                md={3}
                sx={{ display: { xs: "none", sm: "none", md: "initial" } }}
                // xs={12}
                // sx={{
                //   display: { xs: "flex", sm: "flex", md: "none" },
                //   justifyContent: "space-between",
                // }}
              >
                <Box sx={{ paddingBlock: 2 }}>
                  <Typography
                    fontWeight={"700"}
                    fontSize={"20px"}
                    lineHeight={"24px"}
                    style={webStyles.resulteText}
                  >
                    Results{" "}
                    {tabIndex === 0
                      ? bookData?.hits
                        ? bookData?.hits.toLocaleString("en-US")
                        : ""
                      : publisherDetails?.grouped?.publisher_name_tk?.ngroups
                        ? publisherDetails?.grouped?.publisher_name_tk?.ngroups.toLocaleString(
                            "en-US",
                          )
                        : ""}
                  </Typography>
                </Box>

                <CollectionsComponentOfBookPublisher
                  setMyPersonalLibrary={setMyPersonalLibrary}
                  setFilters={setFilters}
                  setCollectionFilter={setCollectionFilter}
                  from={tabIndex === 0 ? "title_atoz" : "bypublisher"}
                ></CollectionsComponentOfBookPublisher>

                <SearchFilterComponentOfBookPublisher
                  setFilters={setFilters}
                  from={tabIndex === 0 ? "title_atoz" : "bypublisher"}
                ></SearchFilterComponentOfBookPublisher>
                {/* <IconButton
                  sx={{
                    display: {
                      xs: "initial",
                      sm: "initial",
                      md: "none",
                    },
                    mr: "15px",
                  }}
                  onClick={() => {
                    setFilterDrawer(true);
                  }}
                  size="small"
                  color="primary"
                >
                  <FilterAlt />
                </IconButton> */}
              </Grid>
            ) : tabIndex == 2 ? (
              <Grid item xs={3}>
                <Box sx={{ paddingBlock: 2 }}>
                  <Typography
                    fontWeight={"700"}
                    fontSize={{ xs: "16px", sm: "20px" }}
                    lineHeight={"24px"}
                    style={webStyles.resulteText}
                  >
                    Results{" "}
                    {packageHits?.hits
                      ? packageHits?.hits.toLocaleString("en-US")
                      : ""}
                  </Typography>
                </Box>
              </Grid>
            ) : null}

            <Box
              sx={{
                display: { xs: "flex", sm: "flex", md: "none" },
                flexDirection: "row",
                justifyContent: "space-between",
                width: { xs: "100%" },
              }}
            >
              <Box>
                {tabIndex === 0 && (
                  <Box sx={{ paddingBlock: 2 }}>
                    <Typography
                      fontWeight={"700"}
                      fontSize={"20px"}
                      lineHeight={"24px"}
                      style={webStyles.resulteText}
                    >
                      Results{" "}
                      {tabIndex === 0
                        ? bookData?.hits
                          ? bookData?.hits.toLocaleString("en-US")
                          : ""
                        : publisherDetails?.grouped?.publisher_name_tk?.ngroups
                          ? publisherDetails?.grouped?.publisher_name_tk?.ngroups.toLocaleString(
                              "en-US",
                            )
                          : ""}
                    </Typography>
                  </Box>
                )}

                {tabIndex === 1 && (
                  <Box sx={{ paddingBlock: 2 }}>
                    <Typography
                      fontWeight={"700"}
                      fontSize={"20px"}
                      lineHeight={"24px"}
                      style={webStyles.resulteText}
                    >
                      Results{" "}
                      {tabIndex === 0
                        ? bookData?.hits
                          ? bookData?.hits.toLocaleString("en-US")
                          : ""
                        : publisherDetails?.grouped?.publisher_name_tk?.ngroups
                          ? publisherDetails?.grouped?.publisher_name_tk?.ngroups.toLocaleString(
                              "en-US",
                            )
                          : ""}
                    </Typography>
                  </Box>
                )}
              </Box>
              <IconButton
                sx={{
                  mr: "15px",
                }}
                onClick={() => {
                  setFilterDrawer(true);
                }}
                size="small"
                color="primary"
              >
                <FilterAlt />
              </IconButton>
            </Box>

            <Grid item xs={12} sm={12} md={tabIndex == 2 ? 12 : 9}>
              {/* Header Div */}
              {tabIndex === 0 ? (
                <Books
                  myPersonalLibrary={myPersonalLibrary}
                  handleEnter={handleEnter}
                  setHandleEnter={setHandleEnter}
                  selectedTag={selectedTag}
                  setSelectFilters={setSelectFilters}
                  filters={filters}
                  selectFilters={selectFilters}
                  setatoz={setatoz}
                  atoz={atoz}
                  keyWords={keyWords}
                  setKeyWord={setKeyWord}
                  searchContainOrStartWith={searchContainOrStartWith}
                  setSelectedTag={setSelectedTag}
                  collectionFilter={collectionFilter}
                  setMyPersonalLibrary={setMyPersonalLibrary}
                  bookmaster_id={bookmaster_id}
                  setSelectedLetterTags={setSelectedLetterTags}
                  logBasicSearchUsageData={logBasicSearchUsageData}
                ></Books>
              ) : tabIndex === 1 ? (
                <BookPublisher
                  // myPersonalLibraryPublisher={myPersonalLibraryPublisher}
                  // keyWords={keyWordsPublisher}
                  // filters={filtersPublisher}
                  selectedTagPublisher={selectedLetterTagsPublisher}
                  filters={filters}
                  setSelectedTag={setSelectedLetterTagsPublisher}
                  setKeyWordPublisher={setKeyWordPublisher}
                  // atozPublisher={atozPublisher}
                  // searchContainOrStartWith={searchContainOrStartWith}
                  // publisher={publisher}
                  // setpublisher={setPublisher}
                  // setFilters={setFiltersPublisher}
                  // setMyPersonalLibraryPublisher={setMyPersonalLibraryPublisher}
                ></BookPublisher>
              ) : tabIndex === 2 ? (
                <Packages
                  setKeyWordPackage={setKeyWordPackage}
                  setSelectedTagPackage={setSelectedTagPackage}
                  setSelectedLetterTagsPackage={setSelectedLetterTagsPackage}
                  filters={filters}
                ></Packages>
              ) : null}
            </Grid>
          </Grid>
          <IconButton
            aria-label="Scroll to Top"
            sx={{
              position: "fixed",
              top: "63vh",
              right: "2vw",
              transform: "translateY(-50%)",
              border: "1px solid #D1D5DB",
              backgroundColor: "#FFF",
              color: "primary.main",
              "&:hover": {
                border: "1px solid #D1D5DB",
                backgroundColor: "#FFF",
                color: "primary.main",
                boxShadow: 2,
              },
            }}
            onClick={() => goToTop()}
          >
            <ArrowUpwardIcon />
          </IconButton>
        </Box>
      </Box>
      <Drawer
        open={true}
        sx={{ display: FilterDrawer ? "block" : "none" }}
        ModalProps={{
          disableScrollLock: true,
        }}
      >
        <Box
          bgcolor={"#FFF"}
          sx={{
            width: {
              xs: "70vw", // extra-small devices (mobile)
              sm: "40vw", // small devices (tablets)
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              width: "100%",
              alignSelf: "center",
              padding: "1%",
            }}
          >
            <Typography
              variant="h6"
              fontFamily={"Lora"}
              fontWeight={"700"}
              fontSize={"24px"}
            >
              Filters
            </Typography>
            <IconButton
              aria-label="delete"
              size="small"
              onClick={() => {
                setFilterDrawer(false);
              }}
            >
              <Clear />
            </IconButton>
          </Box>
        </Box>
        <Divider></Divider>
        <Box width={"100%"}>
          {tabIndex === 0 ? (
            <>
              <CollectionsComponentOfBook
                setMyPersonalLibrary={setMyPersonalLibrary}
                setFilters={setFilters}
                setCollectionFilter={setCollectionFilter}
              ></CollectionsComponentOfBook>

              <SearchFilterComponentOfBook
                setFilters={setFilters}
                from={tabIndex === 0 ? "title_atoz" : "bypublisher"}
              ></SearchFilterComponentOfBook>
            </>
          ) : tabIndex === 1 ? (
            <>
              <CollectionsComponentOfBookPublisher
                setMyPersonalLibrary={setMyPersonalLibrary}
                setFilters={setFilters}
                setCollectionFilter={setCollectionFilter}
                from={tabIndex === 0 ? "title_atoz" : "bypublisher"}
              ></CollectionsComponentOfBookPublisher>

              <SearchFilterComponentOfBookPublisher
                setFilters={setFilters}
                from={tabIndex === 0 ? "title_atoz" : "bypublisher"}
              ></SearchFilterComponentOfBookPublisher>
            </>
          ) : null}
        </Box>
      </Drawer>
    </React.Fragment>
  );
};

const webStyles = {
  button: {
    margin: "0.5%",
    height: 45,
    paddingLeft: "4%",
    paddingRight: "4%",
    borderRadius: 2,
    fontSize: { xs: 10, sm: 12, md: 14 },
  },
  searchTextFont: {
    fontFamily: "Inter",
    fontWeight: 500,
    color: Colors.gray900,
    display: "flex",
    alignItems: "center",
    textAlign: "center",
    borderColor: Colors.gray_400,
    marginLeft: 1,
    textTransform: "none",
    paddingTop: 0,
    paddingBottom: 0,
    minHeight: 22,
    borderRadius: "6px",
    //  fontSize:"0.875rem"
  },
  flexBox: {
    display: "flex",
    flexDirection: "row",
  },
  mainContainer: {
    backgroundColor: "#f5f5f5",
    flex: 1,
  },
  headerText: {
    fontFamily: "Lora",
    color: Colors.primary,
  },
  subText: {
    fontFamily: "Helvetica Neue",
    fontWeight: 700,
    fontSize: "0.9rem",
  },
  checkBox: {
    fontWeight: 400,
    fontSize: "0.875rem",
    color: Colors.primary,
    fontFmaily: "Helvetica Neue",
  },
  textResult: {
    fontFamily: "Lora",
    fontWeight: "700",
    color: Colors.black,
    alignSelf: "center",
    backgroundColor: "green",
    margin: "1% 3.5% 0% 3.5%",
  },
  textInputText: {
    fontFamily: "Helvetica Neue",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: 14,
  },
  resulteText: {
    fontFamily: "Helvetica Neue",
    fontsSyle: "normal",
    fontWeight: 700,
  },
};
